import Image from 'next/legacy/image'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'

import { ReactComponent as AppStoreBadge } from './images/app_store_badge.svg'
import { ReactComponent as Logo } from './images/logo-blk.svg'
import { ReactComponent as PlayStoreBadge } from './images/play_store_badge.svg'
import w2BuildingImg from './images/w2_buildingimg.png'

const AppDownloadBlock = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  @media (max-width: ${breakpoints.ipadMiniMax}) {
    flex-direction: column;
  }
`

const AppDownloadWrapper = styled.div`
  width: 50%;
  height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #e0c6b4;
  @media (max-width: ${breakpoints.ipadMiniMax}) {
    width: 100%;
    height: 100%;
    padding: 50px 0;
  }
`

const AppDownloadContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 375px;
`

const FeatureImageWrapper = styled.div`
  position: relative;
  height: 450px;
  width: 50%;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    width: 100%;
  }

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    height: 250px;
  }
`

const AppDownloadText = styled.p`
  font-size: 24px;
  margin-bottom: 0px;
  width: 100%;
  text-align: center;
  color: ${colors.black};
  @media (max-width: ${breakpoints.phoneMax}) {
    font-size: 18px;
  }
`
const StyledLink = styled.a`
  text-decoration: none;
`

const LivLogoContainer = styled.div`
  margin-top: 30px;
  display: flex;
  width: 254px;
  justify-content: space-between;
  align-items: center;
`

const AppstoreContainer = styled(LivLogoContainer)`
  width: 275px;
`

const AppStore = styled(AppStoreBadge)`
  width: 120px;
`

const PlayStore = styled(PlayStoreBadge)`
  width: 120px;
`
const StyledLogo = styled(Logo)`
  width: 80px;
`

const AppDownload = () => {
  const { t } = useTranslation('w2living')

  return (
    <AppDownloadBlock>
      <FeatureImageWrapper>
        <Image
          src={w2BuildingImg}
          alt=""
          layout="fill"
          objectFit="cover"
          placeholder="blur"
        />
      </FeatureImageWrapper>
      <AppDownloadWrapper>
        <AppDownloadContainer>
          <AppDownloadText>
            {t('w2living:Book your showings & apply now')}
          </AppDownloadText>
          <LivLogoContainer>
            <Link
              href="/"
              passHref
              aria-label={t('b.landing.home.label', 'liv.rent Homepage')}
              legacyBehavior
            >
              <StyledLogo />
            </Link>
            <Link href="/" passHref legacyBehavior>
              <StyledLink>
                <AppDownloadText>www.liv.rent</AppDownloadText>
              </StyledLink>
            </Link>
          </LivLogoContainer>
          <AppstoreContainer>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://apps.apple.com/ca/app/liv-apartment-houses-rental/id1321741040"
            >
              <AppStore />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://play.google.com/store/apps/details?id=rent.liv.ether"
            >
              <PlayStore />
            </a>
          </AppstoreContainer>
        </AppDownloadContainer>
      </AppDownloadWrapper>
    </AppDownloadBlock>
  )
}

export default AppDownload
